import axios from "axios";

export function getScoreTypeList(co) {
    const config = {
        params: co,
    };
    return axios.get(process.env.VUE_APP_API_URL + "ScoringType/getlist", config);
}

